import { render, staticRenderFns } from "./CombiDeals.vue?vue&type=template&id=503dfb86&scoped=true&"
import script from "./CombiDeals.vue?vue&type=script&lang=ts&"
export * from "./CombiDeals.vue?vue&type=script&lang=ts&"
import style0 from "./CombiDeals.vue?vue&type=style&index=0&id=503dfb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503dfb86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCombiDealsItem: require('/var/www/packages/theme/components/molecules/CombiDealsItem.vue').default})
